import { render, staticRenderFns } from "./Listings.vue?vue&type=template&id=dae1b5c4&scoped=true"
import script from "./Listings.vue?vue&type=script&lang=ts"
export * from "./Listings.vue?vue&type=script&lang=ts"
import style0 from "./Listings.vue?vue&type=style&index=0&id=dae1b5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae1b5c4",
  null
  
)

export default component.exports